import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1958dc03"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chat_punch" }
const _hoisted_2 = { class: "ounch_head" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "多语实时字幕", -1))
const _hoisted_4 = { class: "chat_warn" }
const _hoisted_5 = { class: "chat_content" }
const _hoisted_6 = { class: "switch_chat current" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "chat_head" }, "原声语种：", -1))
const _hoisted_8 = { class: "input_area" }
const _hoisted_9 = { class: "switch_chat current" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "chat_head aligin-top translate-10" }, "字幕语种：", -1))
const _hoisted_11 = { class: "input_area form_item_main" }
const _hoisted_12 = { class: "punch_time current" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "time_clock" }, "展示状态：", -1))
const _hoisted_14 = { class: "punch_time current" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "time_clock" }, "观众复制：", -1))
const _hoisted_16 = { class: "drawer_footer" }
const _hoisted_17 = { class: "btn_group" }

import { ref, reactive, computed } from 'vue';
import { Radio, Button, message, Popover, Switch, Alert } from 'ant-design-vue';
import { QuestionCircleFilled, PlusCircleOutlined } from '@ant-design/icons-vue';
import CUpload, { FileItem } from '@/components/CUpload.vue'; // 上传图片  组件
import { useConsoleStore } from '@/pinia/console';

import http from '@/api';
import { useDebounce } from '@/hooks/useDebounce';
import { useLiveStore } from '@/pinia/live';
import { AiSubitObj } from '@/pinia/types/live';
import EventBus from '@/components/EventBus';
interface Optiontype {
  value: number;
  label: string;
  disabled: boolean;
}
interface FileInfo {
  file: FileItem;
  fileList: FileItem[];
}
// S-上传照片

export default /*#__PURE__*/_defineComponent({
  __name: 'AiSubtitlesDrawer',
  emits: ['click:onCloseLotter'],
  setup(__props, { emit }) {

const aRadio = Radio;
const aRadioGroup = Radio.Group;
const aButton = Button;
const aPopover = Popover;
const aSwitch = Switch;
const aAlert = Alert;

const consoleStore = useConsoleStore();
const liveStore = useLiveStore();

const pageLoading = ref(false); //开关
const studioId = consoleStore.consoleInfo.id;
const aiSubit = reactive<AiSubitObj>({
  status: 0,
  switch: 0,
  native_language: 0,
  current_language: 0,
  caption_language: [0],
  logo_switch: 0,
  logo_id: 0,
  logo_url: '',
  subtitle_archive: 0,
  allow_copying: 0,
  display_style: 0,
  caption_switch: 0,
});
const imageUrl = ref<string>('');
const provinceId = ref(''); // 图片id

const langOptions = ref<{ value: number; label: string }[]>([]);
const capLangOptions = computed(() => {
  const arr: Optiontype[] = [];
  langOptions.value.forEach((item, i) => {
    arr[i] = { ...item };
    if (aiSubit.caption_language.includes(item.value)) {
      arr[i].disabled = true;
    } else {
      arr[i].disabled = false;
    }
  });
  return arr;
});

const getData = () => {
  pageLoading.value = false;
  Promise.all([http.live.getCaptionLanguageList(), http.live.getMultSubtitle({ params: { studio_id: studioId } })])
    .then(([res1, res2]) => {
      const resLang = res1.data.data;
      langOptions.value = resLang.reduce((pre, crr: { id: number; language: string }) => {
        pre.push({
          value: crr.id,
          label: crr.language,
        });
        return pre;
      }, [] as any);
      // res2
      const resSubtitle = res2.data.data;
      aiSubit.status = parseInt(resSubtitle.status);
      aiSubit.switch = parseInt(resSubtitle.switch);
      const keywordNat = parseInt(resSubtitle.native_language);
      aiSubit.native_language = keywordNat ? keywordNat : langOptions.value[0].value;
      const keywordCap = parseInt(resSubtitle.current_language);
      aiSubit.current_language = keywordCap ? keywordCap : langOptions.value[0].value;
      const capArritem = resSubtitle.caption_language.split(',').map(Number);
      aiSubit.caption_language = capArritem[0] ? capArritem : [langOptions.value[0].value];
      aiSubit.subtitle_archive = parseInt(resSubtitle.subtitle_archive);
      aiSubit.allow_copying = parseInt(resSubtitle.allow_copying);
      aiSubit.display_style = parseInt(resSubtitle.display_style);
      // aiSubit.logo_switch = parseInt(resSubtitle.logo_switch);
      aiSubit.caption_switch = parseInt(resSubtitle.caption_switch);
      liveStore.aiSubitSwitch = Boolean(aiSubit.switch);
      imageUrl.value = resSubtitle.logo_url;
      provinceId.value = resSubtitle.logo_id;
    })
    .catch((err: any) => {
      message.error(err.data.error);
    })
    .finally(() => {
      pageLoading.value = true;
    });
};

const onAddLangSelect = () => {
  const arr = langOptions.value.find((item) => !aiSubit.caption_language.includes(item.value));
  aiSubit.caption_language.push(arr ? arr.value : 2);
};
const onDelLangSelect = (data: number) => {
  if (aiSubit.caption_language.length <= 1) return;
  aiSubit.caption_language = aiSubit.caption_language.filter((item) => item !== data);
};

const fileList = ref([]);
const loading = ref<boolean>(false);
const handleChange = (info: FileInfo) => {
  if (info.file?.response?.code === 200) {
    imageUrl.value = info.file?.response?.data.url;
    provinceId.value = info.file?.response?.data.id;
  }
  if (info.file.status === 'uploading') {
    loading.value = true;
    return;
  } else loading.value = false;
  if (info.file.status === 'error') {
    loading.value = false;
    message.error('上传失败');
  }
};
const imageDel = (info: any, keywords: number) => {
  provinceId.value = '';
  imageUrl.value = '';
};
// E-上传照片

const save = useDebounce(() => {
  if (aiSubit.caption_language.length && !aiSubit.caption_language.includes(aiSubit.current_language)) {
    aiSubit.current_language = aiSubit.caption_language[0];
  }
  http.live
    .MultSubtitle({
      studio_id: studioId,
      switch: aiSubit.switch,
      status: aiSubit.status,
      native_language: aiSubit.native_language,
      current_language: aiSubit.current_language,
      caption_language: aiSubit.caption_language.join(','),
      display_style: aiSubit.display_style,
      subtitle_archive: aiSubit.subtitle_archive,
      allow_copying: aiSubit.allow_copying,
      logo_switch: aiSubit.logo_switch,
      logo_id: provinceId.value,
      logo_url: imageUrl.value,
    })
    .then((res) => {
      message.success(res.data.message);
      liveStore.aiSubitSwitch = Boolean(aiSubit.switch);
      EventBus.emit('onUpdateSubt');
    })
    .catch((err) => {
      message.error(err.data.error);
    });
});

const init = () => {
  getData();
};
init();

const cancel = () => {
  emit('click:onCloseLotter');
};

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_unref(aSwitch), {
          checked: aiSubit.switch,
          "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((aiSubit.switch) = $event)),
          class: "btns_txt",
          size: "small",
          "checked-value": 1,
          "un-checked-value": 0,
          onChange: _unref(save)
        }, null, 8, ["checked", "onChange"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(aAlert), {
        message: "更改语种需要在发起直播页面，重启实时字幕功能才可生效！",
        banner: "",
        class: "warn_progress"
      })
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_a_select, {
            value: aiSubit.native_language,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((aiSubit.native_language) = $event)),
            class: "ai_select",
            options: langOptions.value
          }, {
            suffixIcon: _withCtx(() => [
              _createVNode(_component_svg_icon, {
                class: "mod_select_icon",
                "icon-class": "list_select"
              })
            ]),
            _: 1
          }, 8, ["value", "options"])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aiSubit.caption_language, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "select_item",
              key: item
            }, [
              _withDirectives(_createVNode(_component_svg_icon, {
                class: "select_item_del",
                "icon-class": "delete_circular_click",
                onClick: ($event: any) => (onDelLangSelect(item))
              }, null, 8, ["onClick"]), [
                [_vShow, aiSubit.caption_language.length > 1]
              ]),
              _createVNode(_component_a_select, {
                value: aiSubit.caption_language[index],
                "onUpdate:value": ($event: any) => ((aiSubit.caption_language[index]) = $event),
                class: "ai_select",
                options: _unref(capLangOptions)
              }, {
                suffixIcon: _withCtx(() => [
                  _createVNode(_component_svg_icon, {
                    class: "mod_select_icon",
                    "icon-class": "list_select"
                  })
                ]),
                _: 2
              }, 1032, ["value", "onUpdate:value", "options"])
            ]))
          }), 128)),
          _createVNode(_unref(aButton), {
            type: "link",
            size: "large",
            class: "cet_btn",
            disabled: aiSubit.caption_language.length === langOptions.value.length,
            onClick: onAddLangSelect
          }, {
            icon: _withCtx(() => [
              _createVNode(_unref(PlusCircleOutlined))
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createVNode(_unref(aRadioGroup), {
          value: aiSubit.status,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((aiSubit.status) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(aRadio), { value: 0 }, {
              default: _withCtx(() => [
                _createTextVNode("独立显示")
              ]),
              _: 1
            }),
            _createVNode(_unref(aRadio), { value: 1 }, {
              default: _withCtx(() => [
                _createTextVNode("嵌入视频")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createVNode(_unref(aSwitch), {
          checked: aiSubit.allow_copying,
          "onUpdate:checked": _cache[3] || (_cache[3] = ($event: any) => ((aiSubit.allow_copying) = $event)),
          size: "small",
          checkedValue: 1,
          unCheckedValue: 0
        }, null, 8, ["checked"])
      ])
    ], 512), [
      [_vShow, pageLoading.value]
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_unref(aButton), {
          class: "mod_modal_btn",
          onClick: cancel
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_unref(aButton), {
          class: "mod_modal_btn mod_type_primary",
          onClick: _unref(save)
        }, {
          default: _withCtx(() => [
            _createTextVNode("保存")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ]))
}
}

})